"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoint = useBreakpoint;

var _mediaQuery = require("@react-hook/media-query");

var _theme = require("../theme");

var _mediaQueryFns = require("./mediaQueryFns");

function useBreakpoint(breakpointName) {
  var mediaQueryFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _mediaQueryFns.mediaQueryAbove;
  var theme = (0, _theme.usePabloTheme)();
  var breakpointIndex = theme.breakpoints.breakpointNames.findIndex(function (bp) {
    return bp === breakpointName;
  });
  var mediaQuery = mediaQueryFn(theme.breakpoints, breakpointIndex);
  return (0, _mediaQuery.useMediaQuery)(mediaQuery);
}